import { ChannelProvider } from "@pandas/realtime";
import { createFileRoute } from "@tanstack/react-router";
import SplashScreen from "@/features/onboarding/pages/splash-screen/SplashScreen";
import { useStore } from "@/store";

function SplashScreenRoute() {
	const sessionId = useStore((state) => state.sessionId);
	return (
		<ChannelProvider channelName={sessionId}>
			<SplashScreen />
		</ChannelProvider>
	);
}

export const Route = createFileRoute("/$locale/$partner/")({
	component: SplashScreenRoute,
});
